import Avatar from '@shared/components/Avatar/Avatar';
import Checkbox from '@shared/components/Checkbox/Checkbox';

interface InviteWorkspaceMemberItemProps {
  name: string;
  onClick: () => void;
  isSelected: boolean;
}

const InviteWorkspaceMemberItem = ({ name, onClick, isSelected }: InviteWorkspaceMemberItemProps) => (
  <div className="flex py-1 justify-between items-center">
    <div className="flex gap-4 items-center min-w-0">
      <div className="relative">
        <Avatar size="xs" name={name} />
        {/* {isOnline && ( //TODO: logic not implemented yet for this indicator https://github.com/meedio/meedio/issues/7169
          <div className="absolute -bottom-0.5 -right-0.5 bg-primaryComp-50 border border-white rounded-[4px] h-[10px] w-[10px]" />
        )} */}
      </div>
      <span className="text-size-sm font-medium truncate">{name}</span>
    </div>
    <Checkbox checked={isSelected} onChange={onClick} />
  </div>
);

export default InviteWorkspaceMemberItem;
